import {FormControl, Grid, InputLabel, MenuItem, Select, withStyles} from "@material-ui/core";
import React from "react";
import styles from './styles';
import AxlDateTimePicker from "../../../AxlDateTimePicker";
import moment from "moment";


const PERIOD_OPTIONS = [
    {label: 'This week', value: 'this-week'},
    {label: 'Last week', value: 'last-week'},
    {label: 'Two weeks ago', value: '2-weeks-ago'},
    {label: 'This month', value: 'this-month'},
    {label: 'Last month', value: 'last-month'},
    {label: 'Two months ago', value: '2-months-ago'},
    {label: 'This year', value: 'this-year'},
    {label: 'Last year', value: 'last-year'},
];

let DATE_TYPES = [
    // {label: 'Specific Date', value: 'date'},
    {label: 'Date Range', value: 'range'},
    // {label: 'Period', value: 'period'}
];

export const DATE_TYPE_DEFAULT = {
    dateType: 'range',
    period: null,
    from: null,
    to: null
}

class DateType extends React.Component {


    handleChange = (updated) =>
    {
        const {name,handleOnChange} = this.props;
        handleOnChange(name, updated);
    }

    handleDateTypeChange = (event, value) => {
        const {currentValue} = this.props;
        if (currentValue && currentValue.dateType !== value) {
            this.handleChange({
                ...currentValue,
                dateType: value
            });
        }
    }

    handleFieldChange = (field, value) => {
        const {currentValue} = this.props;
        this.handleChange({
            ...currentValue,
            [field]: value
        });
    }

    handleDateChange = (e) => {
        const {currentValue} = this.props;

        if (!e.target) return;
        const {value,name} = e.target;

        const date = moment(value).format("yyyy-MM-DD")



        if (currentValue.dateType === 'date') {
            this.handleChange({
                ...currentValue,
                date: date
            });

        } else if (currentValue.dateType === 'range') {
            const dt = moment(value).toDate();
            if (name === 'from') {
                dt.setHours(0, 0, 0, 0);
                this.handleChange({
                    ...currentValue,
                    from: dt.getTime()
                });
            } else if (name === 'to') {
                dt.setHours(23, 59, 59, 0);
                this.handleChange({
                    ...currentValue,
                    to: dt.getTime()
                });
            }
        }
    }

    render() {

        const {classes, currentValue, pulling} = this.props;
        return (
            <Grid container>
                <Grid item xs={4} style={{marginTop: 10}}>
                    <FormControl variant="outlined" disabled={pulling} className={classes?.formControl}>
                        <InputLabel>Date Type</InputLabel>
                        <Select
                            label="Date Type"
                            fullWidth
                            displayEmpty
                            disabled={pulling}
                            value={currentValue?.dateType ? currentValue.dateType : undefined}
                            onChange={(e) => this.handleDateTypeChange(e, e.target.value)}
                        >
                            {DATE_TYPES.map((option) => (
                                <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={4} style={{marginTop: 10, marginLeft: 2}}>
                    {currentValue && currentValue.dateType && currentValue.dateType === 'period' && (
                        <FormControl variant="outlined" disabled={pulling} className={classes.formControl}>
                            <InputLabel>Period</InputLabel>
                            <Select
                                label="Period"
                                fullWidth
                                displayEmpty
                                disabled={pulling}
                                value={currentValue?.period ? currentValue.period : undefined}
                                onChange={(e) => this.handleFieldChange(e,"period", e.target.value)}
                            >
                                {PERIOD_OPTIONS.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Grid>
                {currentValue && currentValue.dateType && currentValue.dateType !== 'period' && (
                    <Grid container>
                        <Grid item xs={4} style={{marginTop: 10}}>
                            {currentValue.dateType !== 'period' && (
                                <AxlDateTimePicker
                                    dateOnly
                                    format="yyyy/MM/DD"
                                    label={currentValue?.dateType === 'date' ? "Date" : "From Date"}
                                    name={currentValue?.dateType === 'date' ? "date" : "from"}
                                    variant="outlined"
                                    fullWidth
                                    disabled={pulling}
                                    maxDate={currentValue?.dateType === 'range' && currentValue.to ? currentValue.to : undefined}
                                    value={currentValue?.dateType === 'date' ? currentValue.date : currentValue.from ? currentValue.from : null}
                                    onChange={this.handleDateChange}
                                />
                            )}
                        </Grid>
                        <Grid item xs={4} style={{marginTop: 10}}>
                            {currentValue.dateType === 'range' && (
                                <AxlDateTimePicker
                                    dateOnly
                                    format="yyyy/MM/DD"
                                    label="To Date"
                                    variant="outlined"
                                    name="to"
                                    fullWidth
                                    disabled={pulling}
                                    minDate={currentValue.dateType === 'range' && currentValue.from ? currentValue.from : undefined}
                                    value={currentValue.to ? currentValue.to : null}
                                    onChange={this.handleDateChange}
                                />
                            )}
                        </Grid>
                    </Grid>
                )}
            </Grid>
        )
    }
}

export default withStyles(styles)(DateType);